import { PlayIcon, WandIcon } from "lucide-react";
import React from "react";
import { AspectRatio } from "../../../../components/ui/aspect-ratio";
import { Button } from "../../../../components/ui/button";
import { Card, CardContent } from "../../../../components/ui/card";
import { Separator } from "../../../../components/ui/separator";

export const MainContentSection = (): JSX.Element => {
  return (
    <section className="w-full px-4 sm:px-6 py-8 sm:py-16">
      {/* Call to Action Section */}
      <div className="bg-black text-white rounded-2xl sm:rounded-3xl px-4 sm:px-8 py-8 sm:py-12 w-full max-w-[1920px] mx-auto relative overflow-hidden">
        {/* Background Image */}
        <div 
          className="absolute inset-0 z-0"
          style={{
            backgroundImage: "url('/bent-light-blue-shape-on-black-background-glowing 2.jpg')",
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            opacity: 0.4
          }}
        />

        {/* Grid Overlay */}
        <div 
          className="absolute inset-0 z-10 opacity-30"
          style={{
            backgroundImage: "url('/Grid 1 (1).jpg')",
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            mixBlendMode: "overlay"
          }}
        />

        {/* Asphalt Texture Overlay */}
        <div 
          className="absolute inset-0 z-20 opacity-30"
          style={{
            backgroundImage: "url('/asfalt--light--1920x1080.png')",
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            mixBlendMode: "overlay"
          }}
        />

        <div className="w-[140px] h-[140px] top-0 right-0 rounded-[70px] blur-[202px] absolute bg-[#d9d9d9] z-30" />

        <img
          className="absolute w-[120px] sm:w-[249px] h-auto top-[-34px] left-[-57px] z-30"
          alt="Vector"
          src="/vector-4.svg"
        />
        <img
          className="absolute w-[30px] sm:w-[50px] h-auto bottom-[59px] right-[122px] sm:right-[222px] z-30"
          alt="Vector"
          src="/vector-5.svg"
        />
        <img
          className="absolute w-[40px] sm:w-[63px] h-auto top-[29px] right-[26px] sm:right-[46px] z-30"
          alt="Vector"
          src="/vector-2.svg"
        />
        <img
          className="absolute w-[30px] sm:w-[46px] h-auto top-[37px] left-32 sm:left-52 z-30"
          alt="Vector"
          src="/vector-2.svg"
        />

        <div className="flex flex-col items-center gap-6 sm:gap-[58px] relative z-40">
          <h2 className="max-w-4xl font-satoshi font-semibold text-white text-3xl sm:text-4xl md:text-5xl text-center tracking-[-0.48px] leading-tight sm:leading-[74px]">
            No limitations<br className="hidden sm:block"/> 
            <span className="block text-2xl sm:text-4xl md:text-5xl mt-2 sm:mt-0">
              Empower your workforce, streamline operations, and lead with clarity
            </span>
          </h2>

          <Button className="bg-white hover:bg-white/80 group rounded-[55px] px-6 sm:px-[34px] py-3 sm:py-3.5 w-full sm:w-auto">
            <span className="font-satoshi font-medium text-black text-sm sm:text-base text-center tracking-[0] leading-[normal]">
              Create an Account
            </span>
          </Button>
        </div>
      </div>
    </section>
  );
};